module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "70%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("2")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("One week later")])])])]), _c('p', {
    staticClass: "chapterDateline1",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Oakbrook, Illinois")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("I")])])])]), _vm._v(" looked out my kitchen window. The Saturday afternoon sun was lighting the empty swing set and the bare winter ground. Another endless Saturday lay before me. I could remember, in a distant way, a time when my weekends were packed with activity and bursting with possibility.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I picked up the phone and called Liza’s cell phone. “It’s your sad, pathetic friend Kate,” I said when she answered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t call yourself sad,” said Liza.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Can I still call myself pathetic?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Absolutely.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I laughed. Talking to Liza was about the only thing that got me laughing anymore.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you back?” I asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I was back, and I left again.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Where were you last week?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Montreal. And I got something for you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Liza Kingsley was always finding gifts for me on her travels. In Tokyo, she bought me a handbag in taupe-colored silk. I carried it for years until the lining began to shred. When Liza was in Budapest, she sent back a handwoven rug swirled with gold and celadon green. She was always going to London and bringing me packets of sweets from Harrods and, once, a cocktail dress in a chocolate brown, which she said would complement my eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She was that kind of a friend. A great friend. Her friendship went beyond thoughtful gifts and a shared history. It was her phone calls and her visits and her cheerleading and her love that had propped me up and sustained me since Scott left.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("And now this souvenir from Montreal.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Tell me,” I said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I found you a man.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I coughed. “What?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“He’s amazing,” Liza said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not ready to date.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Kate, it’s been ten months since he left. It’s time to dip your toe in the waters.” A pause. “And look, you’re not going to "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("date.")])]), _vm._v(" You’d just go on "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("a")])]), _vm._v(" date.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Wind forced one of the swings into the air. A second later, it listed to a halt. “I don’t think so.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“His name is Michael Waller.” She paused. “And he’s French.” Now she had a little goad in her voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t kid.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s true. Well, he’s American, but he’s of French descent, and he speaks the language fluently.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re taunting me.” Liza knew that French men, or at least men who could speak French, were my downfall. It was a trait uniquely embarrassing, because everyone I knew hated French men. Such men were thought pompous. Affected. Liza and I had grown up in Evanston, Illinois, but I’d spent six months after high school in a small town outside Paris, where I fell in love with a boy named Jacques. It was tragic. It was ridiculous. But I was hooked on the accent and the hooded eyes and the utter disdain French men carried for everyone, including themselves.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“It’s true,” Liza said again. “Of course, it’s just one of the six languages he knows.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Stop.” I turned away from the window and leaned against the stainless steel fridge.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“All true.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How old is he?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She cleared her throat. “He’s a little older than you.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Spill it, Liza.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Michael is a very young fifty-five.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s seventeen years "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("older")])]), _vm._v(" than me!”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I know, I know, but I wouldn’t recommend him if I didn’t think he was the perfect rebound man. Remember, this is just for fun.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But seventeen years?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey, Scott was our age, and that didn’t make a damn bit of difference, did it?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I squeezed my eyes closed. It stung, yet Liza was absolutely right. The only thing that had made a difference was that I couldn’t have a child. Oh, I could get pregnant with a little medical assistance—and I did three times, in fact—but such pregnancies always ended in miscarriages. My body rejected the babies, and in return, Scott rejected me. Having a family was the most important thing in the world to him, even more important than his wife. And he was fiercely opposed to adoption. He wanted a baby who was "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("his,")])]), _vm._v(" he’d said over and over. Strangely, I didn’t think I even wanted children anymore. The quest had sucked me dry, left me with little maternal desire. So Michael’s age didn’t matter in that respect.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You there?” Liza said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Unfortunately. I’m stuck in the house that Scott built.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sell it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I will. Soon. I just can’t take any more changes for a while.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What you need is a good night out with a nice, attractive man.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And that’s it? A night out?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That’s it. He lives in Vermont but he visits Chicago for business. It’s perfect.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How do you know him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Work. He used to be at Presario. I haven’t seen him in years, but I ran into him in Montreal. And how fantastic is this? He’s opening a restaurant called the Twilight Club in St. Marabel. It’s outside Montreal.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Exactly how am I supposed to date a man who lives in Vermont and is opening a business in Canada?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Have you not heard me? I’m just talking about one date.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Why don’t "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("you")])]), _vm._v(" date him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She made a snorting sound. “He’s not my type, and I have no interest in the French thing, unlike you. So can I have him call you? He’s coming to Chicago to meet with investors for his restaurant. He’s staying at the Peninsula.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Expensive.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, he’s got money. I’m telling you, this guy has everything, Kate—looks, smarts, money, sense of humor.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I stood away from the fridge and walked into the powder room just outside the kitchen. I flicked on the light and looked at myself in the mirror. “I’d need a haircut,” I said. My blond hair, which I normally wore to my chin, had become unruly over the past few months. The too-long bangs had to be pushed aside now and the ends were in desperate need of a trim.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So get a haircut, for Christ’s sake,” Liza said. “Get some new clothes, get a massage, treat yourself. Head down to Michigan Avenue and do some Christmas shopping.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Maybe,” I said in a noncommittal way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The truth was, I’d lacked motivation of any kind since Scott took off. For the first time in my adult life, I hadn’t even put up a Christmas tree. All I could manage was to drive to work every day, which was tough since I’d come to despise my job as an accountant at a medical-supply company. Before Scott and I got married, I used to work downtown at a big accounting agency, where we had major clients with interesting portfolios. Most people consider accounting boring, but I’ve always loved the order of it. My job seemed a challenging puzzle. But once I began working in medical supplies there were very few puzzles. Instead, I was crunching numbers about bedpans and catheters. The job was easier than my old one—and it was just a ten-minute drive from the house—but these things mattered only when Scott and I assumed we’d be having children. At least I hadn’t changed my name. My family’s name, Greenwood, was the one thing about my life that still felt like mine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“God, I wish I was there to get you out of that house,” Liza said.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Where are you now?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Copenhagen.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Liza had an apartment in Chicago overlooking Lake Michigan, but as the head of international sales for Presario Pharmaceuticals, she was often globe-trotting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your cell phone works in Copenhagen?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“My cell phone works everywhere. And if it doesn’t I forward it to one that does.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How is Copenhagen?” I asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Freaking freezing.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Are you having any fun?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“When do I have time for fun?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Liza, you can’t work all the time.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Shut up, we’re talking about your pathetic life, remember? Let him take you to dinner.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re relentless.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Someone’s got to be. So what do you say?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("I groaned. And yet I felt buoyed just by talking to Liza. She had that effect on me. I glanced out the powder-room window at the lonely swing set. “All right. Have him call me.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52167cd2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/goodliarthe_ch02.vue
// module id = 72
// module chunks = 0